module.exports = __webpack_public_path__ + "img/crizal-black.d3ffaa3b.svg";